"use client"

import { blogSlug, postsPerPage } from "components/Blog/utils/Blog.utils"
import { PreviewNotification } from "packages/ui-shared/components/PreviewNotification"
import React from "react"
import type { BlogAuthorFeedType } from "types/blog-v2-types"
import { siteUrl } from "utils/getSiteUrl"
import { AuthorBio } from "../../components/Author/AuthorBio"
import { AuthorFollow } from "../../components/Author/AuthorFollow"
import { AuthorHero } from "../../components/Author/AuthorHero"
import { AuthorPosts } from "../../components/Author/AuthorPosts"
import { BlogPageHeader } from "../../components/Shared/BlogPageHeader"
import { BlogPagination } from "../../components/Shared/BlogPagination"
import { Breadcrumb } from "../../components/Shared/Breadcrumb"

import { container, noPosts } from "./Author.css"

type Props = {
  authorDetails: BlogAuthorFeedType["authorDetails"]
  entries: BlogAuthorFeedType["entries"]
  totalPosts: BlogAuthorFeedType["totalPosts"]["total"]
  currentPage: BlogAuthorFeedType["currentPage"]["pageNum"]
  preview?: boolean
  locale: "en-GB" | "en-US"
}

export const Author: React.FC<Props> = ({
  authorDetails,
  entries,
  totalPosts,
  currentPage,
  preview,
  locale,
}) => {
  const { fullName, slug, image, biography, twitter, instagram, linkedIn } =
    authorDetails
  const showFollow = twitter || instagram || linkedIn
  const siteSlug = `${siteUrl}${locale === "en-US" ? "/us" : ""}`
  return (
    <div className={container}>
      {preview && (
        <PreviewNotification
          slug={`${siteSlug}${blogSlug}/author/${slug}`}
          locale={locale}
        />
      )}
      <Breadcrumb title={fullName} slug={slug} slugPrefix="author" />
      <BlogPageHeader title={fullName} />
      {image && <AuthorHero image={image} />}
      {biography && <AuthorBio content={biography} />}
      {showFollow && (
        <AuthorFollow
          fullName={fullName}
          twitter={twitter}
          instagram={instagram}
          linkedIn={linkedIn}
        />
      )}
      {entries?.length ? (
        <>
          <AuthorPosts fullName={fullName} authorPosts={entries} />
          <BlogPagination
            totalItems={totalPosts}
            currentPage={currentPage}
            itemsPerPage={postsPerPage}
            slug={`${blogSlug}/author/${slug}`}
            noHeroImage
            locale={locale}
          />
        </>
      ) : (
        <p className={noPosts}>No posts here yet!</p>
      )}
    </div>
  )
}
